/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusPrivacyPolicyDetailDto } from '../../models/lexplus-privacy-policy-detail-dto';

export interface PrivacyPolicyControllerUploadPdfV1$Params {
  id: number;
  sprache: string;
      body: {
'file': Blob;
}
}

export function privacyPolicyControllerUploadPdfV1(http: HttpClient, rootUrl: string, params: PrivacyPolicyControllerUploadPdfV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusPrivacyPolicyDetailDto>> {
  const rb = new RequestBuilder(rootUrl, privacyPolicyControllerUploadPdfV1.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('sprache', params.sprache, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusPrivacyPolicyDetailDto>;
    })
  );
}

privacyPolicyControllerUploadPdfV1.PATH = '/v1/privacy-policies/{id}/pdf/{sprache}';
